<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ service.title }}: {{ promotion.title }}</strong
                    >
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks :service-name="serviceName" />
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotion.title
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Тип</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotionTypeTitle(promotion.type)
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.discount }} %</CCol
                        >
                    </CRow>
                    <CRow v-if="promotion.orders_quantity" form class="form-group">
                        <CCol sm="3" class="col-form-label">Количество первых заказов в заведении по акции</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.orders_quantity }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка от ресторана (%) </CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.entity_discount_percent ? promotion.entity_discount_percent + "%" : "" }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка от ресторана (руб.) </CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.entity_discount_sum ? promotion.entity_discount_sum + " р." : "" }}</CCol
                        >
                    </CRow>
                    <Schedule class="font-bold"  :schedule="schedule" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Комиссия МИРСИТИ (%) </CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.mircity_commission ? promotion.mircity_commission + "%" : "" }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Дата начала</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotion.date_start
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            sm="3"
                            class="col-form-label"
                        >Дата окончания</CCol
                        >
                        <CCol sm="9" class="col-form-label">{{
                            promotion.date_finish
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время начала</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotion.time_from
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            sm="3"
                            class="col-form-label"
                        >Время окончания</CCol
                        >
                        <CCol sm="9" class="col-form-label">{{
                            promotion.time_to
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            sm="3"
                            class="col-form-label"
                        >Неограничено (срок)</CCol
                        >
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(promotion.unlimited)">
                                &nbsp;{{
                                    promotion.unlimited ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Тип доставки</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ labelDeliveryType(promotion.delivery_type) }}
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Учитывать при интеграции</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(promotion.accounting_in_integration)">
                                &nbsp;{{
                                    promotion.accounting_in_integration ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(promotion.enabled)">
                                &nbsp;{{
                                    promotion.enabled ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import PromotionsTabLinks from '@/components/promotions/PromotionsTabLinks';
    import Schedule from '@/components/ScheduleWorkPromotion';
    import { promotionTypeTitle } from '../../utils/promotion-views';
    import { getRouteName } from '../../utils/route-name';
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {
        name: 'Promotion',

        components: {
            PromotionsTabLinks,
            Schedule,
        },

        data() {
            return {
                serviceName: getRouteName(this.$router.currentRoute.path),
                service: {},
                promotion: {},
                schedule: undefined,
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            const promotion_id = parseInt(this.$route.params.promotion_id);
            let url = `/${this.serviceName}/${id}`;

            if (this.serviceName === 'entities') {
                url = `/${this.serviceName}/get/${id}`
            }
            Vue.axios
                .get(url)
                .then(resp => {
                    this.service = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                })
            Vue.axios
                .get('/promotions/' + promotion_id)
                .then(resp => {
                    this.promotion = resp.data;
                    if (this.promotion.date_start) {
                        this.promotion.date_start = moment(this.promotion.date_start).format('YYYY-MM-DD');
                    }
                    if (this.promotion.date_finish) {
                        this.promotion.date_finish = moment(this.promotion.date_finish).format('YYYY-MM-DD');
                    }
                    this.promotion.time_from = this.promotion.time_from
                        ? moment('Mon Jun 28 2021 ' + this.promotion.time_from + ' GMT+0000').local().format('HH:mm:ss')
                        : null;
                    this.promotion.time_to = this.promotion.time_to
                        ? moment('Mon Jun 28 2021 ' + this.promotion.time_to + ' GMT+0000').local().format('HH:mm:ss')
                        : 0;
                    if(resp.data.schedule.length != 0) {
                        this.schedule = resp.data.schedule;
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            labelDeliveryType (delivery_type) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });

                for (const type of types) {
                    if(delivery_type === type.value){
                        return type.label;
                    }
                }
                return '';
            },
            goBack() {
                let path = `/${this.serviceName}/${this.service.id}/promotions`;

                if (this.serviceName === 'entities') {
                    path = `/entities/${this.$route.params.code}/${this.$route.params.id}/promotions`
                }
                this.$router.push({ path });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            promotionTypeTitle(type) {
                return promotionTypeTitle(type);
            }
        },
    };
</script>
